import React, { Component } from "react";

export default class FaqItem extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.open !== undefined) {
      return { isOpen: nextProps.open };
    }
    return null;
  }
  state = { isOpen: false };
  render() {
    const { isOpen } = this.state;
    const { title, children } = this.props;

    return (
      <div
        className={isOpen ? "faq-item active" : "faq-item"}
        onClick={() => {
          this.setState(prevState => ({ isOpen: !prevState.isOpen }));
        }}
      >
        <div class="faq-title">
          <span class="fa fa-angle-down" />
          {title}
        </div>
        <div class="faq-text">{children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/FaqItem/index.js